import { BackButtonConfig } from 'contexts/BackButtonContext';
import { BackButtonSearchParams } from './types';

export const getBackButtonSearchParams = (backButtonConfig: BackButtonConfig) => {
  const params = new URLSearchParams();
  params.set(BackButtonSearchParams.TITLE, backButtonConfig.title);
  params.set(BackButtonSearchParams.TO, backButtonConfig.to);
  return params;
};
